export const FILTER_TITLE = 'Гибкий поиск организаций';
export const ORGANIZATION_ROUTE = 'organization';
export const ORGANIZATIONS_ROUTE = 'organizations';
export const ORGANIZATIONS_MAP_ROUTE = 'organizationsmap';
export const FILTER_NAV = [
  {
    text: 'Каталог',
    variant: 'catalog',
    to: {
      name: ORGANIZATIONS_ROUTE,
    },
  },
  {
    text: 'Карта',
    variant: 'map',
    to: {
      name: ORGANIZATIONS_MAP_ROUTE,
    },
  },
];



// WEBPACK FOOTER //
// ./src/pages/organizations/const.ts